import moment from 'moment'
import apiClient from './apiClient'
import { API_DATE } from '../momentjs'

export const getInstitutionBadges = (user, institution, parameters = { date: moment().format(API_DATE) }) =>
  apiClient.get(user, `api/institutions/${institution.id}/badge-assignations`, parameters)

export const recoverBadgeAssignation = (user, institution, badgeAssignation, body) =>
  apiClient.patch(user, `badges/updateAssignationAndAddBadgeIfNotExist/${institution.id}/${badgeAssignation.id}`, body)

export const deleteBadgeAssignation = (user, badgeAssignation) =>
  apiClient.delete(user, `api/BadgeAssignation/${badgeAssignation.id}`)

export const createBadgeAssignation = (user, institution, body) =>
  apiClient.post(user, `badges/addAssignationAndBadgeIfNotExist/${institution.id}`, body)

export const updateBadgeAssignation = (user, institution, badgeAssignation, body) =>
  apiClient.patch(user, `badges/updateAssignationAndAddBadgeIfNotExist/${institution.id}/${badgeAssignation.id}`, body)
